/**
 * @packageDocumentation
 * @module f1/string
 */

import { TParseFormatOptions } from '../types';
import text_list from '../data/text_list';
import json from '../data/json';

export type t_field_type = 'text_list' | 'json';

const _ = { text_list, json };

export interface Parse {
  /**
   * parse a value from a string representation
   *
   * @public
   * @function f1.parse
   * @param parse_type parse type such as text, text_list, json etc.
   * @param options
   * @param value any value
   * @example
   *
   * ```ts
   * f1.parse('text_list', {}, 'list1, list2') //=> ["list1", "list2"]
   * f1.parse('json', {}, '["list1", "list2"]') //=> ['list1', 'list2']
   * ```
   */
  <V>(parse_type: t_field_type, options: TParseFormatOptions, value: string): V;
  <V>(parse_type: t_field_type, options: TParseFormatOptions): (value: string) => V;
}

export default <V>(parse_type: t_field_type, options: TParseFormatOptions, value: string): V => {
  // we use any because these functions will not be called in typescript often, but
  // next to APIs at runtime and form a boundary for applications. They need to use type
  // but their runtime rules should be robust.
  //
  return (_[parse_type].parse(options, value) as unknown) as V;
};
